/**
 * Formulaire produit cadre : options variante (ordre Shopify), champs course, validation.
 */
(function () {
  var MIN_COURSE_CHECKED = 1;
  var MAX_COURSE_CHECKED = 6;
  var DATE_RE = /^(\d{2})\.(\d{2})\.(\d{4})$/;

  function formatMoney(cents, moneyFormat) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, moneyFormat || '{{amount}}');
    }
    var n = (Number(cents) / 100).toFixed(2);
    return n.replace('.', ',') + ' €';
  }

  /* ── Temps officiel forcé en HHhMMmSSs ── */
  function pad2(n) {
    var v = Math.max(0, parseInt(n, 10) || 0);
    return String(v).padStart(2, '0');
  }

  function validOfficialTime(str) {
    var m = String(str).trim().match(/^(\d{2})h(\d{2})m(\d{2})s$/i);
    if (!m) return false;
    var mn = parseInt(m[2], 10);
    var sec = parseInt(m[3], 10);
    return mn >= 0 && mn <= 59 && sec >= 0 && sec <= 59;
  }

  function formatOfficialTime(raw) {
    var s = String(raw || '').trim().toLowerCase();
    if (!s) return '';

    var groups = s.match(/\d+/g);
    if (!groups || !groups.length) return String(raw).trim();

    var h = 0;
    var mn = 0;
    var sec = 0;

    if (groups.length >= 3) {
      h = parseInt(groups[0], 10) || 0;
      mn = parseInt(groups[1], 10) || 0;
      sec = parseInt(groups[2], 10) || 0;
    } else if (groups.length === 2) {
      h = parseInt(groups[0], 10) || 0;
      mn = parseInt(groups[1], 10) || 0;
    } else {
      var digits = groups[0];
      if (digits.length === 6) {
        h = parseInt(digits.slice(0, 2), 10) || 0;
        mn = parseInt(digits.slice(2, 4), 10) || 0;
        sec = parseInt(digits.slice(4, 6), 10) || 0;
      } else {
        return String(raw).trim();
      }
    }

    if (mn > 59 || sec > 59) return String(raw).trim();
    return pad2(h) + 'h' + pad2(mn) + 'm' + pad2(sec) + 's';
  }

  /* ── Allure forcée en MM:SS min/km ── */
  function validPace(str) {
    var m = String(str).trim().match(/^(\d{2}):(\d{2}) min\/km$/i);
    if (!m) return false;
    var sec = parseInt(m[2], 10);
    return sec >= 0 && sec <= 59;
  }

  function formatPace(raw) {
    var s = String(raw || '').trim().toLowerCase();
    if (!s) return '';

    var groups = s.match(/\d+/g);
    if (!groups || !groups.length) return String(raw).trim();

    var mn = 0;
    var sec = 0;

    if (groups.length >= 2) {
      mn = parseInt(groups[0], 10) || 0;
      sec = parseInt(groups[1], 10) || 0;
    } else {
      var digits = groups[0];
      if (digits.length === 4) {
        mn = parseInt(digits.slice(0, 2), 10) || 0;
        sec = parseInt(digits.slice(2, 4), 10) || 0;
      } else {
        return String(raw).trim();
      }
    }

    if (sec > 59) return String(raw).trim();
    return pad2(mn) + ':' + pad2(sec) + ' min/km';
  }

  function validRanking(str) {
    var m = String(str).trim().match(/^(\d+)\/(\d+)$/);
    if (!m) return false;
    var rank = parseInt(m[1], 10);
    var total = parseInt(m[2], 10);
    return rank > 0 && total > 0 && rank <= total;
  }

  function formatRanking(raw) {
    var groups = String(raw || '').trim().match(/\d+/g);
    if (!groups || groups.length < 2) return String(raw || '').trim();
    return parseInt(groups[0], 10) + '/' + parseInt(groups[1], 10);
  }

  function parseVariants(form) {
    var el = form.querySelector('[data-rs-variants-json]');
    if (!el || !el.textContent) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }

  function parseVariantConstraints(form) {
    var el = form.querySelector('[data-rs-variant-constraints-json]');
    if (!el || !el.textContent) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }

  function getMoneyFormat(form) {
    var n = form.querySelector('[data-rs-money-format]');
    return n ? n.getAttribute('data-rs-money-format') || '' : '';
  }

  function getI18n(form, key) {
    var span = form.querySelector('[data-rs-i18n-' + key + ']');
    return span ? span.getAttribute('data-rs-i18n-' + key) || '' : '';
  }

  function optionCount(form) {
    var n = parseInt(form.getAttribute('data-rs-option-count'), 10);
    return isNaN(n) ? 0 : n;
  }

  function getVariantOptionValue(variant, pos) {
    if (!variant) return '';
    return variant['option' + String(pos)] || '';
  }

  function variantRadiosByName(form) {
    var map = {};
    form.querySelectorAll('[data-rs-variant-option]').forEach(function (r) {
      if (!map[r.name]) map[r.name] = [];
      map[r.name].push(r);
    });
    return map;
  }

  function getSelectedVariantOptions(form) {
    var count = optionCount(form);
    var map = {};
    var i;
    for (i = 1; i <= count; i++) {
      var inp = form.querySelector('[data-rs-variant-option="' + i + '"]:checked:not(:disabled)');
      if (!inp) inp = form.querySelector('[data-rs-variant-option="' + i + '"]:checked');
      map[i] = inp ? inp.value : '';
    }
    return map;
  }

  function findVariantFromSelection(variants, map, count) {
    if (!variants || !variants.length) return null;
    return variants.find(function (v) {
      var i;
      for (i = 1; i <= count; i++) {
        if ((getVariantOptionValue(v, i) || '') !== (map[i] || '')) return false;
      }
      return true;
    });
  }

  function getDossierDimensions(form) {
    var wInp = form.querySelector('[data-rs-dossier-dim="w"]');
    var hInp = form.querySelector('[data-rs-dossier-dim="h"]');
    if (!wInp || !hInp) return null;
    var w = parseFloat(String(wInp.value).replace(',', '.'), 10);
    var h = parseFloat(String(hInp.value).replace(',', '.'), 10);
    if (isNaN(w) || isNaN(h) || w <= 0 || h <= 0) return null;
    return { w: w, h: h };
  }

  function syncCheckedPerGroup(form) {
    var byName = variantRadiosByName(form);
    Object.keys(byName).forEach(function (nm) {
      var group = byName[nm];
      var checked = group.filter(function (r) { return r.checked; })[0];
      if (checked && checked.disabled) {
        checked.checked = false;
        var firstOk = group.filter(function (r) { return !r.disabled; })[0];
        if (firstOk) firstOk.checked = true;
      }
      if (!group.some(function (r) { return r.checked; })) {
        var pick = group.filter(function (r) { return !r.disabled; })[0];
        if (pick) pick.checked = true;
      }
    });
  }

  function updateFrameSizeConstraints(form, variants, moneyFormat, variantConstraints) {
    var radios = form.querySelectorAll('[data-rs-variant-option]');
    if (!radios.length) {
      applyVariant(form, variants, moneyFormat);
      return;
    }

    var dims = getDossierDimensions(form);
    var hintEl = form.querySelector('[data-rs-dossier-frame-hint]');
    var constrainedRadiosCount = 0;
    var blockedConstraintCount = 0;
    var byName = variantRadiosByName(form);
    var selectedMap = getSelectedVariantOptions(form);
    var count = optionCount(form);

    Object.keys(byName).forEach(function (nm) {
      var group = byName[nm];
      var first = group[0];
      var pos = first ? parseInt(first.getAttribute('data-rs-variant-option'), 10) : NaN;
      if (isNaN(pos)) return;

      group.forEach(function (radio) {
        var val = radio.value;
        var candidates = (variantConstraints || []).filter(function (vc) {
          if ((vc['option' + pos] || '') !== val) return false;
          var i;
          for (i = 1; i <= count; i++) {
            if (i === pos) continue;
            if (selectedMap[i] && (vc['option' + i] || '') !== selectedMap[i]) return false;
          }
          return true;
        });

        var constrainedCandidates = candidates.filter(function (vc) {
          var maxW = parseFloat(vc.maxW);
          var maxH = parseFloat(vc.maxH);
          return !isNaN(maxW) && !isNaN(maxH);
        });

        var hasConstraint = constrainedCandidates.length > 0;
        var label = radio.closest('.rs-product-form__pill');
        var blocked = false;
        if (dims && hasConstraint) {
          blocked = !constrainedCandidates.some(function (vc) {
            var maxW = parseFloat(vc.maxW);
            var maxH = parseFloat(vc.maxH);
            return dims.w <= maxW && dims.h <= maxH;
          });
        }
        radio.disabled = blocked;
        if (label) label.classList.toggle('rs-product-form__pill--blocked', blocked);
        if (hasConstraint) {
          constrainedRadiosCount++;
          if (blocked) blockedConstraintCount++;
        }
      });
    });

    if (hintEl) {
      if (dims && constrainedRadiosCount > 0 && blockedConstraintCount === constrainedRadiosCount) {
        hintEl.textContent = getI18n(form, 'dossier-too-large') || 'Aucune taille disponible pour ces dimensions de dossard.';
        hintEl.hidden = false;
      } else if (dims && blockedConstraintCount > 0) {
        hintEl.textContent = getI18n(form, 'frame-limited-hint') || 'Pour garantir un rendu visuel optimal, certaines tailles de cadre sont indisponibles pour ce dossard';
        hintEl.hidden = false;
      } else {
        hintEl.textContent = '';
        hintEl.hidden = true;
      }
    }

    syncCheckedPerGroup(form);
    applyVariant(form, variants, moneyFormat);
    refreshSubmitAvailability(form);
  }

  function applyVariant(form, variants, moneyFormat) {
    var count = optionCount(form);
    if (count < 1) {
      var idInput0 = form.querySelector('[data-rs-variant-input]');
      var vid = idInput0 ? parseInt(idInput0.value, 10) : NaN;
      var v0 = variants.find(function (x) { return x.id === vid; });
      if (!v0) v0 = variants[0];
      if (!v0) return;
      var idIn0 = form.querySelector('[data-rs-variant-input]');
      if (idIn0) idIn0.value = v0.id;
      var priceEl0 = form.querySelector('[data-rs-product-price]');
      if (priceEl0) priceEl0.textContent = formatMoney(v0.price, moneyFormat);
      document.dispatchEvent(new CustomEvent('rs:variant-change', { detail: { variant: v0 } }));
      updateHookDiff(form, variants, moneyFormat);
      return;
    }

    var byName = variantRadiosByName(form);
    var nm;
    for (nm in byName) {
      if (!Object.prototype.hasOwnProperty.call(byName, nm)) continue;
      var g = byName[nm];
      if (!g.some(function (r) { return !r.disabled; })) {
        var priceElDash = form.querySelector('[data-rs-product-price]');
        if (priceElDash) priceElDash.textContent = '\u2014';
        return;
      }
    }

    var map = getSelectedVariantOptions(form);
    var i;
    for (i = 1; i <= count; i++) {
      if (!map[i]) {
        var priceElEmpty = form.querySelector('[data-rs-product-price]');
        if (priceElEmpty) priceElEmpty.textContent = '\u2014';
        return;
      }
    }

    var v = findVariantFromSelection(variants, map, count);
    if (!v) v = variants[0];
    if (!v) return;

    var idInput = form.querySelector('[data-rs-variant-input]');
    if (idInput) idInput.value = v.id;

    var priceEl = form.querySelector('[data-rs-product-price]');
    if (priceEl) priceEl.textContent = formatMoney(v.price, moneyFormat);

    document.dispatchEvent(new CustomEvent('rs:variant-change', { detail: { variant: v } }));
    updateHookDiff(form, variants, moneyFormat);
  }

  function validateDossierFrameConstraints(form, variantConstraints) {
    var radios = form.querySelectorAll('[data-rs-variant-option]');
    if (!radios.length) return '';
    var dims = getDossierDimensions(form);
    if (!dims) return '';
    var byName = variantRadiosByName(form);
    var nm;
    for (nm in byName) {
      if (!Object.prototype.hasOwnProperty.call(byName, nm)) continue;
      var group = byName[nm];
      if (!group.some(function (r) { return !r.disabled; })) return getI18n(form, 'dossier-too-large');
    }
    var count = optionCount(form);
    var map = getSelectedVariantOptions(form);
    var selectedConstraint = (variantConstraints || []).find(function (vc) {
      var i;
      for (i = 1; i <= count; i++) {
        if ((vc['option' + i] || '') !== (map[i] || '')) return false;
      }
      return true;
    });
    if (selectedConstraint) {
      var maxW = parseFloat(selectedConstraint.maxW, 10);
      var maxH = parseFloat(selectedConstraint.maxH, 10);
      if (!isNaN(maxW) && !isNaN(maxH) && (dims.w > maxW || dims.h > maxH)) {
        return getI18n(form, 'dossier-incompatible');
      }
    }
    return '';
  }

  function updateHookDiff(form, variants, moneyFormat) {
    var el = form.querySelector('[data-rs-hook-diff]');
    var count = optionCount(form);
    if (!el || count < 2) {
      if (el) el.textContent = '';
      return;
    }
    var lastPos = count;
    var map = getSelectedVariantOptions(form);
    var i;
    for (i = 1; i < lastPos; i++) {
      if (!map[i]) { el.textContent = ''; return; }
    }
    var subs = variants.filter(function (v) {
      var j;
      for (j = 1; j < lastPos; j++) {
        if ((getVariantOptionValue(v, j) || '') !== (map[j] || '')) return false;
      }
      return true;
    });
    if (subs.length < 2) { el.textContent = ''; return; }
    var prices = subs.map(function (v) { return v.price; });
    var minP = Math.min.apply(null, prices);
    var maxP = Math.max.apply(null, prices);
    if (minP === maxP) { el.textContent = ''; return; }
    var delta = maxP - minP;
    var tpl = getI18n(form, 'hook-supplement');
    var amt = formatMoney(delta, moneyFormat);
    el.textContent = tpl ? tpl.split('%amount%').join(amt) : '+' + amt;
  }

  function setCourseCheckboxesState(form) {
    var boxes = Array.prototype.slice.call(form.querySelectorAll('[data-rs-course-checkbox]'));
    var checked = boxes.filter(function (b) { return b.checked; });
    var atMax = checked.length >= MAX_COURSE_CHECKED;
    boxes.forEach(function (b) {
      b.disabled = !b.checked && atMax;
    });
  }

  function toggleCoursePanel(checkbox) {
    var block = checkbox.closest('[data-rs-course-block]');
    if (!block) return;
    var panel = block.querySelector('[data-rs-course-panel]');
    var inputs = block.querySelectorAll('[data-rs-course-input]');
    var summaryInputs = block.querySelectorAll('[data-rs-course-summary-input]');
    var on = checkbox.checked;
    if (panel) panel.hidden = !on;
    checkbox.setAttribute('aria-expanded', on ? 'true' : 'false');
    inputs.forEach(function (inp) {
      inp.disabled = !on;
      if (!on) {
        if (inp.type === 'checkbox') return;
        inp.value = '';
        inp.classList.remove('is-invalid');
      }
    });
    summaryInputs.forEach(function (inp) {
      inp.disabled = !on;
      if (!on) inp.value = '';
    });
    var err = block.querySelector('[data-rs-field-error]');
    if (err) { err.hidden = true; err.textContent = ''; }
    if (on) {
      var limitInp = block.querySelector('[data-rs-char-limit]');
      if (limitInp) updateCharCount(limitInp);
    }
  }

  function updateCharCount(input) {
    var block = input.closest('[data-rs-course-block]');
    if (!block) return;
    var countEl = block.querySelector('[data-rs-char-count]');
    var max = parseInt(input.getAttribute('data-rs-char-limit'), 10) || 25;
    if (countEl) countEl.textContent = input.value.length + ' / ' + max;
  }

  function validDateDDMMYYYY(str) {
    var m = String(str).trim().match(DATE_RE);
    if (!m) return false;
    var d = parseInt(m[1], 10), mo = parseInt(m[2], 10) - 1, y = parseInt(m[3], 10);
    var dt = new Date(y, mo, d);
    return dt.getFullYear() === y && dt.getMonth() === mo && dt.getDate() === d;
  }

  function isValidUrl(str) {
    try { new URL(str); return true; } catch (e) { return false; }
  }

  function hasUnavailableVariantGroup(form) {
    var byName = variantRadiosByName(form);
    return Object.keys(byName).some(function (nm) {
      return !byName[nm].some(function (r) { return !r.disabled; });
    });
  }

  function areRequiredFieldsFilled(form) {
    var wInp = form.querySelector('[data-rs-dossier-dim="w"]');
    var hInp = form.querySelector('[data-rs-dossier-dim="h"]');
    var dimsInputs = [wInp, hInp].filter(Boolean);
    if (dimsInputs.length) {
      var dossierOk = dimsInputs.every(function (inp) {
        var v = parseFloat(String(inp.value || '').replace(',', '.'));
        return !isNaN(v) && v > 0;
      });
      if (!dossierOk) return false;
    }

    var radioGroups = {};
    form.querySelectorAll('[type="radio"][name^="properties["]').forEach(function (r) {
      if (r.closest('[data-rs-course-panel]')) return;
      if (!radioGroups[r.name]) radioGroups[r.name] = [];
      radioGroups[r.name].push(r);
    });

    return Object.keys(radioGroups).every(function (name) {
      return radioGroups[name].some(function (r) { return r.checked && !r.disabled; });
    });
  }

  function areCheckedCourseFieldsValid(form) {
    var blocks = form.querySelectorAll('[data-rs-course-block]');
    if (blocks.length && form.querySelectorAll('[data-rs-course-checkbox]:checked').length < MIN_COURSE_CHECKED) {
      return false;
    }
    for (var i = 0; i < blocks.length; i++) {
      var block = blocks[i];
      var cb = block.querySelector('[data-rs-course-checkbox]');
      if (cb && !cb.checked) continue;

      var inputs = block.querySelectorAll('[data-rs-course-input]:not([disabled])');
      for (var j = 0; j < inputs.length; j++) {
        var inp = inputs[j];
        var v = (inp.value || '').trim();
        if (!v) return false;
        if (inp.hasAttribute('data-rs-date-field') && !validDateDDMMYYYY(v)) return false;
        if (inp.hasAttribute('data-rs-url-field') && !isValidUrl(v)) return false;
        if (inp.hasAttribute('data-rs-duration-field') && !validOfficialTime(v)) return false;
        if (inp.hasAttribute('data-rs-ranking-field') && !validRanking(v)) return false;
        if (inp.hasAttribute('data-rs-pace-field') && !validPace(v)) return false;
      }
    }
    return true;
  }

  function validateGpxField(form) {
    var gpxInput = form.querySelector('[data-rs-gpx-file]');
    if (!gpxInput) return '';

    var files = gpxInput.files;
    if (!files || !files.length) return 'Veuillez joindre un fichier GPX (.gpx).';

    var fileName = (files[0].name || '').toLowerCase();
    if (!/\.gpx$/.test(fileName)) return 'Seuls les fichiers .gpx sont acceptes.';

    return '';
  }

  function setSubmitDisabledState(form, disabled) {
    var submitBtn = form.querySelector('[data-rs-submit]');
    if (submitBtn) submitBtn.disabled = !!disabled;

    var root = form.closest('.rs-main-product');
    if (!root) return;
    root.querySelectorAll('[data-rs-ext-cta]').forEach(function (btn) {
      btn.disabled = !!disabled;
      btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    });
  }

  function refreshSubmitAvailability(form) {
    var gpxErr = validateGpxField(form);
    var disabled =
      hasUnavailableVariantGroup(form) ||
      !areRequiredFieldsFilled(form) ||
      !areCheckedCourseFieldsValid(form) ||
      !!gpxErr;
    setSubmitDisabledState(form, disabled);
  }

  /* ── Validation des champs obligatoires (dossard + choix metafield) ── */
  function validateRequiredFields(form) {
    var dossierMsg = getI18n(form, 'required-dossier') || 'Veuillez renseigner les dimensions du dossard.';
    var choiceMsg  = getI18n(form, 'required-choice')  || 'Merci de faire un choix.';
    var firstError = '';

    /* 1. Taille du dossard */
    var dossierErr = form.querySelector('[data-rs-dossier-error]');
    var wInp = form.querySelector('[data-rs-dossier-dim="w"]');
    var hInp = form.querySelector('[data-rs-dossier-dim="h"]');
    var dossierInvalid = false;

    [wInp, hInp].forEach(function (inp) {
      if (!inp) return;
      var v = parseFloat(String(inp.value).replace(',', '.'));
      if (!inp.value || isNaN(v) || v <= 0) {
        inp.classList.add('is-invalid');
        dossierInvalid = true;
      } else {
        inp.classList.remove('is-invalid');
      }
    });

    if (dossierInvalid) {
      if (dossierErr) { dossierErr.textContent = dossierMsg; dossierErr.hidden = false; }
      if (!firstError) firstError = dossierMsg;
    } else {
      if (dossierErr) dossierErr.hidden = true;
    }

    /* 2. Groupes radio propriétés (couleur, motif…)
       On cherche directement tous les radios name="properties[...]",
       sans dépendre de data-rs-mf-fieldset, plus robuste.
       Les radios dans un panel course (data-rs-course-panel) sont exclus. */
    var radioGroups = {};
    form.querySelectorAll('[type="radio"][name^="properties["]').forEach(function (r) {
      if (r.closest('[data-rs-course-panel]')) return;
      if (!radioGroups[r.name]) radioGroups[r.name] = [];
      radioGroups[r.name].push(r);
    });

    Object.keys(radioGroups).forEach(function (name) {
      var group    = radioGroups[name];
      var chosen   = group.some(function (r) { return r.checked; });
      var fieldset = group[0].closest('[data-rs-mf-fieldset]');
      var errEl    = fieldset ? fieldset.querySelector('[data-rs-group-error]') : null;

      if (!chosen) {
        if (fieldset) fieldset.classList.add('is-invalid');
        if (errEl) { errEl.textContent = choiceMsg; errEl.hidden = false; }
        if (!firstError) firstError = choiceMsg;
      } else {
        if (fieldset) fieldset.classList.remove('is-invalid');
        if (errEl) errEl.hidden = true;
      }
    });

    return firstError;
  }

  /* ── Validation avant submit : marque les champs invalides visuellement ── */
  function validateCourseFields(form) {
    var dateMsg   = getI18n(form, 'date-invalid')  || 'Date invalide (JJ.MM.AAAA).';
    var urlMsg    = getI18n(form, 'url-invalid')   || 'URL invalide.';
    var timeMsg   = getI18n(form, 'official-time-invalid') || 'Temps officiel invalide. Format attendu : 00h00m00s.';
    var rankMsg   = getI18n(form, 'ranking-invalid') || 'Classement invalide. Format attendu : 235/1299.';
    var paceMsg   = getI18n(form, 'pace-invalid') || 'Allure invalide. Format attendu : 00:00 min/km.';
    var minMsg    = getI18n(form, 'course-min') || 'Sélectionnez au moins 1 champ de course.';
    var emptyMsg  = getI18n(form, 'course-incomplete') || 'Champs course incomplets.';

    var firstError = '';
    var blocks = form.querySelectorAll('[data-rs-course-block]');
    if (blocks.length && form.querySelectorAll('[data-rs-course-checkbox]:checked').length < MIN_COURSE_CHECKED) {
      return minMsg;
    }

    for (var i = 0; i < blocks.length; i++) {
      var block = blocks[i];
      var cb = block.querySelector('[data-rs-course-checkbox]');
      if (cb && !cb.checked) continue;

      var inputs = block.querySelectorAll('[data-rs-course-input]:not([disabled])');
      for (var j = 0; j < inputs.length; j++) {
        var inp = inputs[j];
        var v = (inp.value || '').trim();
        var err = block.querySelector('[data-rs-field-error]');

        if (v === '') {
          inp.classList.add('is-invalid');
          if (err) { err.textContent = emptyMsg; err.hidden = false; }
          if (!firstError) firstError = emptyMsg;
          continue;
        }

        inp.classList.remove('is-invalid');
        if (err) { err.hidden = true; err.textContent = ''; }

        if (inp.hasAttribute('data-rs-date-field') && !validDateDDMMYYYY(v)) {
          inp.classList.add('is-invalid');
          if (err) { err.textContent = dateMsg; err.hidden = false; }
          if (!firstError) firstError = dateMsg;
        }

        if (inp.hasAttribute('data-rs-url-field') && !isValidUrl(v)) {
          inp.classList.add('is-invalid');
          if (err) { err.textContent = urlMsg; err.hidden = false; }
          if (!firstError) firstError = urlMsg;
        }

        if (inp.hasAttribute('data-rs-duration-field') && !validOfficialTime(v)) {
          inp.classList.add('is-invalid');
          if (err) { err.textContent = timeMsg; err.hidden = false; }
          if (!firstError) firstError = timeMsg;
        }

        if (inp.hasAttribute('data-rs-ranking-field') && !validRanking(v)) {
          inp.classList.add('is-invalid');
          if (err) { err.textContent = rankMsg; err.hidden = false; }
          if (!firstError) firstError = rankMsg;
        }

        if (inp.hasAttribute('data-rs-pace-field') && !validPace(v)) {
          inp.classList.add('is-invalid');
          if (err) { err.textContent = paceMsg; err.hidden = false; }
          if (!firstError) firstError = paceMsg;
        }
      }
    }
    return firstError;
  }

  function showFormError(form, text) {
    var el = form.querySelector('[data-rs-form-error]');
    if (!el) return;
    el.textContent = text || '';
    el.hidden = !text;
    if (text) el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function bindCourseFields(form) {
    form.querySelectorAll('[data-rs-course-checkbox]').forEach(function (cb) {
      cb.addEventListener('change', function () {
        toggleCoursePanel(cb);
        setCourseCheckboxesState(form);
      });
    });

    form.querySelectorAll('[data-rs-char-limit]').forEach(function (inp) {
      inp.addEventListener('input', function () { updateCharCount(inp); });
    });

    /* Fusion distance + d+ pour n'envoyer qu'une ligne dans les propriétés */
    form.querySelectorAll('[data-rs-double-row]').forEach(function (row) {
      var block = row.closest('[data-rs-course-block]');
      if (!block) return;
      var kmInp = row.querySelector('[data-rs-double-km]');
      var dplusInp = row.querySelector('[data-rs-double-dplus]');
      var summaryInp = block.querySelector('[data-rs-double-summary]');
      if (!kmInp || !dplusInp || !summaryInp) return;

      var syncSummary = function () {
        var km = (kmInp.value || '').trim();
        var dplus = (dplusInp.value || '').trim();
        summaryInp.value = (km && dplus) ? (km + ' km / ' + dplus + ' d+') : '';
      };

      kmInp.addEventListener('input', syncSummary);
      dplusInp.addEventListener('input', syncSummary);
      syncSummary();
    });

    /* Effacer is-invalid dès que l'utilisateur corrige un champ */
    form.querySelectorAll('[data-rs-course-input]').forEach(function (inp) {
      inp.addEventListener('input', function () {
        inp.classList.remove('is-invalid');
        var err = inp.closest('[data-rs-course-block]') && inp.closest('[data-rs-course-block]').querySelector('[data-rs-field-error]');
        if (err) { err.hidden = true; err.textContent = ''; }
      });
    });

    /* Date : formatage automatique à la saisie (DD.MM.YYYY) + validation au blur */
    form.querySelectorAll('[data-rs-date-field]').forEach(function (inp) {
      inp.addEventListener('keydown', function (e) {
        /* Autoriser : backspace, delete, tab, escape, enter, flèches, copier/coller/couper, sélection tout */
        if (
          e.key === 'Backspace' || e.key === 'Delete' ||
          e.key === 'Tab' || e.key === 'Escape' || e.key === 'Enter' ||
          e.key === 'ArrowLeft' || e.key === 'ArrowRight' ||
          e.key === 'ArrowUp' || e.key === 'ArrowDown' ||
          (e.ctrlKey || e.metaKey)
        ) return;
        /* Bloquer tout ce qui n'est pas un chiffre */
        if (!/^\d$/.test(e.key)) e.preventDefault();
      });

      inp.addEventListener('input', function () {
        var pos = inp.selectionStart;
        var raw = inp.value.replace(/\D/g, '').slice(0, 8);
        var formatted = raw;
        if (raw.length > 4) {
          formatted = raw.slice(0, 2) + '.' + raw.slice(2, 4) + '.' + raw.slice(4);
        } else if (raw.length > 2) {
          formatted = raw.slice(0, 2) + '.' + raw.slice(2);
        }
        if (inp.value !== formatted) {
          /* Ajustement de la position du curseur après insertion du point */
          var dotsBeforeOld = (inp.value.slice(0, pos).match(/\./g) || []).length;
          var dotsBeforeNew = (formatted.slice(0, pos).match(/\./g) || []).length;
          inp.value = formatted;
          var newPos = pos + (dotsBeforeNew - dotsBeforeOld);
          /* Décale le curseur après le point auto-inséré */
          if (formatted[pos] === '.' && formatted[pos - 1] !== '.') newPos = pos + 1;
          inp.setSelectionRange(newPos, newPos);
        }
      });

      inp.addEventListener('blur', function () {
        var err = inp.closest('[data-rs-course-block]') && inp.closest('[data-rs-course-block]').querySelector('[data-rs-field-error]');
        var v = (inp.value || '').trim();
        if (!v || !err) return;
        if (!validDateDDMMYYYY(v)) {
          err.textContent = getI18n(form, 'date-invalid');
          err.hidden = false;
          inp.classList.add('is-invalid');
        } else {
          err.hidden = true;
          inp.classList.remove('is-invalid');
        }
      });
    });

    /* URL : validation au blur */
    form.querySelectorAll('[data-rs-url-field]').forEach(function (inp) {
      inp.addEventListener('blur', function () {
        var err = inp.closest('[data-rs-course-block]') && inp.closest('[data-rs-course-block]').querySelector('[data-rs-field-error]');
        var v = (inp.value || '').trim();
        if (!v) { if (err) { err.hidden = true; } return; }
        if (!isValidUrl(v)) {
          inp.classList.add('is-invalid');
          if (err) { err.textContent = getI18n(form, 'url-invalid'); err.hidden = false; }
        } else {
          inp.classList.remove('is-invalid');
          if (err) { err.hidden = true; }
        }
      });
    });

    /* Temps officiel : format forcé HHhMMmSSs */
    form.querySelectorAll('[data-rs-duration-field]').forEach(function (inp) {
      inp.setAttribute('placeholder', inp.getAttribute('placeholder') || '00h00m00s');

      inp.addEventListener('keydown', function (e) {
        if (
          e.key === 'Backspace' || e.key === 'Delete' ||
          e.key === 'Tab' || e.key === 'Escape' || e.key === 'Enter' ||
          e.key === 'ArrowLeft' || e.key === 'ArrowRight' ||
          e.key === 'ArrowUp' || e.key === 'ArrowDown' ||
          (e.ctrlKey || e.metaKey)
        ) return;
        /* Autoriser chiffres + séparateurs usuels (h/m/s, :, ', ") */
        if (!/^[\dhms:'"]$/i.test(e.key)) e.preventDefault();
      });

      inp.addEventListener('blur', function () {
        var v = (inp.value || '').trim();
        var err = inp.closest('[data-rs-course-block]') && inp.closest('[data-rs-course-block]').querySelector('[data-rs-field-error]');
        if (!v) { if (err) err.hidden = true; return; }
        inp.value = formatOfficialTime(v);
        if (!validOfficialTime(inp.value)) {
          inp.classList.add('is-invalid');
          if (err) { err.textContent = getI18n(form, 'official-time-invalid') || 'Temps officiel invalide. Format attendu : 00h00m00s.'; err.hidden = false; }
        } else {
          inp.classList.remove('is-invalid');
          if (err) err.hidden = true;
        }
      });
    });

    /* Allure : format forcé MM:SS min/km */
    form.querySelectorAll('[data-rs-pace-field]').forEach(function (inp) {
      inp.setAttribute('placeholder', inp.getAttribute('placeholder') || '00:00 min/km');

      inp.addEventListener('keydown', function (e) {
        if (
          e.key === 'Backspace' || e.key === 'Delete' ||
          e.key === 'Tab' || e.key === 'Escape' || e.key === 'Enter' ||
          e.key === 'ArrowLeft' || e.key === 'ArrowRight' ||
          e.key === 'ArrowUp' || e.key === 'ArrowDown' ||
          (e.ctrlKey || e.metaKey)
        ) return;
        /* Autoriser chiffres + séparateurs usuels (:, espace, min, /, km) */
        if (!/^[\d: mink/]$/i.test(e.key)) e.preventDefault();
      });

      inp.addEventListener('blur', function () {
        var v = (inp.value || '').trim();
        var err = inp.closest('[data-rs-course-block]') && inp.closest('[data-rs-course-block]').querySelector('[data-rs-field-error]');
        if (!v) { if (err) err.hidden = true; return; }
        inp.value = formatPace(v);
        if (!validPace(inp.value)) {
          inp.classList.add('is-invalid');
          if (err) { err.textContent = getI18n(form, 'pace-invalid') || 'Allure invalide. Format attendu : 00:00 min/km.'; err.hidden = false; }
        } else {
          inp.classList.remove('is-invalid');
          if (err) err.hidden = true;
        }
      });
    });

    /* Classement : format forcé rang/total */
    form.querySelectorAll('[data-rs-ranking-field]').forEach(function (inp) {
      inp.addEventListener('keydown', function (e) {
        if (
          e.key === 'Backspace' || e.key === 'Delete' ||
          e.key === 'Tab' || e.key === 'Escape' || e.key === 'Enter' ||
          e.key === 'ArrowLeft' || e.key === 'ArrowRight' ||
          e.key === 'ArrowUp' || e.key === 'ArrowDown' ||
          (e.ctrlKey || e.metaKey)
        ) return;
        if (!/^[\d/]$/.test(e.key)) e.preventDefault();
      });

      inp.addEventListener('input', function () {
        var cleaned = (inp.value || '').replace(/[^\d/]/g, '');
        var slashPos = cleaned.indexOf('/');
        if (slashPos !== -1) {
          cleaned = cleaned.slice(0, slashPos + 1) + cleaned.slice(slashPos + 1).replace(/\//g, '');
        }
        if (cleaned !== inp.value) inp.value = cleaned;
      });

      inp.addEventListener('blur', function () {
        var v = (inp.value || '').trim();
        var err = inp.closest('[data-rs-course-block]') && inp.closest('[data-rs-course-block]').querySelector('[data-rs-field-error]');
        if (!v) { if (err) err.hidden = true; return; }
        inp.value = formatRanking(v);
        if (!validRanking(inp.value)) {
          inp.classList.add('is-invalid');
          if (err) { err.textContent = getI18n(form, 'ranking-invalid') || 'Classement invalide. Format attendu : 235/1299.'; err.hidden = false; }
        } else {
          inp.classList.remove('is-invalid');
          if (err) err.hidden = true;
        }
      });
    });

    /* État initial */
    form.querySelectorAll('[data-rs-course-checkbox]').forEach(function (cb) {
      toggleCoursePanel(cb);
    });
    setCourseCheckboxesState(form);
  }

  function bindGpxDialog(form) {
    var openBtn = form.querySelector('[data-rs-gpx-open]');
    var closeBtn = form.querySelector('[data-rs-gpx-close]');
    var dlg = form.querySelector('[data-rs-gpx-dialog]');
    if (!openBtn || !dlg) return;

    function portGpxDialogToBody() {
      if (dlg.parentNode !== document.body) document.body.appendChild(dlg);
    }

    openBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      /* Hors du formulaire : évite bugs WebKit (stacking / clipping) avec ancêtres en grid / scroll */
      portGpxDialogToBody();
      try {
        if (typeof dlg.showModal === 'function') dlg.showModal();
        else dlg.setAttribute('open', 'open');
      } catch (err) {
        dlg.setAttribute('open', 'open');
      }
      /* Evite le scroll de la page vers le 1er focusable (mobile) : focus sur le dialog */
      try {
        dlg.focus({ preventScroll: true });
      } catch (e2) {
        try { dlg.focus(); } catch (e3) { /* noop */ }
      }
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        if (typeof dlg.close === 'function') dlg.close();
        else dlg.removeAttribute('open');
      });
    }
  }

  function initForm(form) {
    if (!form || form.dataset.rsProductFormInit === '1') return;
    form.dataset.rsProductFormInit = '1';

    var variants = parseVariants(form);
    var variantConstraints = parseVariantConstraints(form);
    var moneyFormat = getMoneyFormat(form);

    form.querySelectorAll('[data-rs-variant-option]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        updateFrameSizeConstraints(form, variants, moneyFormat, variantConstraints);
      });
    });

    form.querySelectorAll('[data-rs-dossier-dim]').forEach(function (inp) {
      var recompute = function () {
        updateFrameSizeConstraints(form, variants, moneyFormat, variantConstraints);
      };
      inp.addEventListener('input', function () {
        recompute();
      });
      inp.addEventListener('change', function () {
        recompute();
      });
      /* Certains navigateurs n'émettent pas toujours "input" sur type=number tant que focus actif */
      inp.addEventListener('keyup', recompute);
    });

    bindCourseFields(form);
    bindGpxDialog(form);
    updateFrameSizeConstraints(form, variants, moneyFormat, variantConstraints);

    /* Effacer is-invalid dossard au remplissage */
    form.querySelectorAll('[data-rs-dossier-dim]').forEach(function (inp) {
      inp.addEventListener('input', function () {
        inp.classList.remove('is-invalid');
        var errEl = form.querySelector('[data-rs-dossier-error]');
        if (errEl) errEl.hidden = true;
      });
    });

    /* Effacer is-invalid sur les groupes metafield au choix d'un radio */
    form.querySelectorAll('[type="radio"][name^="properties["]').forEach(function (radio) {
      if (radio.closest('[data-rs-course-panel]')) return;
      radio.addEventListener('change', function () {
        var fieldset = radio.closest('[data-rs-mf-fieldset]');
        if (fieldset) {
          fieldset.classList.remove('is-invalid');
          var errEl = fieldset.querySelector('[data-rs-group-error]');
          if (errEl) errEl.hidden = true;
        }
      });
    });

    form.addEventListener('input', function () { refreshSubmitAvailability(form); });
    form.addEventListener('change', function () { refreshSubmitAvailability(form); });
    form.addEventListener('blur', function () { refreshSubmitAvailability(form); }, true);
    refreshSubmitAvailability(form);

    form.addEventListener('submit', function (e) {
      showFormError(form, '');

      var errGpx = validateGpxField(form);
      if (errGpx) {
        e.preventDefault();
        showFormError(form, errGpx);
        return;
      }

      var errReq = validateRequiredFields(form);
      if (errReq) {
        e.preventDefault();
        showFormError(form, errReq);
        return;
      }
      var errD = validateDossierFrameConstraints(form, variantConstraints);
      if (errD) {
        e.preventDefault();
        showFormError(form, errD);
        return;
      }
      var err = validateCourseFields(form);
      if (err) {
        e.preventDefault();
        showFormError(form, err);
      }
    });
  }

  function boot() {
    document.querySelectorAll('form[data-rs-product-form]').forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
